import { useMemo } from "react";
import {
  buildMassParentTable,
  buildMassSeries,
  buildObjectsSeries,
  buildOutletSeries,
  buildVolumeSeries,
} from "../utils/metrics";
const useCharacterizationMetrics = ({
  materialDelivery = [],
  totalWasteMass = 0,
  totalWasteVolume = 0,
  recoverableMaterialList = [],
  parentCategoriesList = [],
  totalVolumeRecoverable = 0,
  totalMassRecoverable = 0,
  recoverableWithOutlet = 0,
  recoverableWithNoOutlet = 0,
}) => {
  return useMemo(() => {
    if (!materialDelivery.length && !parentCategoriesList.length) return {};
    const mass = buildMassSeries({
      materialDelivery,
      totalWasteMass,
      parentCategoriesList,
    });
    const volume = buildVolumeSeries({
      materialDelivery,
      totalWasteVolume,
      totalVolumeRecoverable,
      recoverableMaterialList,
    });
    const objects = buildObjectsSeries({ materialDelivery });
    const outlet = buildOutletSeries({
      recoverableWithOutlet,
      recoverableWithNoOutlet,
      totalMassRecoverable,
      totalWasteMass,
      parentCategoriesList,
    });
    const parentTable = buildMassParentTable({
      parentCategoriesList,
      totalWasteMass,
      totalWeight: totalMassRecoverable,
    });
    return { mass, volume, objects, outlet, parentTable };
  }, [
    materialDelivery,
    totalWasteMass,
    parentCategoriesList,
    totalWasteVolume,
    totalVolumeRecoverable,
    recoverableMaterialList,
    recoverableWithOutlet,
    recoverableWithNoOutlet,
    totalMassRecoverable,
  ]);
};
export default useCharacterizationMetrics;
